Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaOffer = exports.schemaPerson = exports.schemaStore = exports.schemaArticle = exports.schemaBlog = exports.schemaProduct = exports.schemaSearch = exports.schemaWebSite = exports.schemaBreadcrumbs = exports.schemaListItem = exports.schemaImage = exports.schemaAddress = exports.schemaOrg = exports.schemaData = exports.schemaTemplate = exports.schemaDocument = exports.schemaContent = void 0;
const utils_1 = require("./utils");
const schemaTypes = (data, mapping) => Object.keys(mapping).find(key => data === null || data === void 0 ? void 0 : data.hasOwnProperty(key)) || "";
const schemaContent = metadata => ((metadata === null || metadata === void 0 ? void 0 : metadata.schema) && (metadata === null || metadata === void 0 ? void 0 : metadata.schema(metadata))) || (0, exports.schemaWebSite)(metadata);
exports.schemaContent = schemaContent;
const schemaDocument = (data, mapping) => ((data === null || data === void 0 ? void 0 : data.hasOwnProperty(schemaTypes(data, mapping))) ? data[schemaTypes(data, mapping)] : {});
exports.schemaDocument = schemaDocument;
const schemaTemplate = (template = null, item = null, templateMapping = null) => {
    var _a;
    const mapping = templateMapping || { title: (item === null || item === void 0 ? void 0 : item.title) || "", description: ((_a = item === null || item === void 0 ? void 0 : item.description) === null || _a === void 0 ? void 0 : _a.split(".")[0]) || "" };
    const regex = new RegExp(Object.keys(mapping)
        .map(key => `\{${key}\}`)
        .join("|"), "gi");
    return template
        ? Object.entries(template).reduce((obj, [key, value]) => (Object.assign(Object.assign({}, obj), { [key]: value.replace(regex, item => mapping[item.replace(/[{}]/g, "")]) })), {})
        : null;
};
exports.schemaTemplate = schemaTemplate;
const schemaData = ({ breadcrumbs, data, global, language, organisation = null, preferences = null, routes, social, template = null, templateMapping = null, tracking, url, }, mapping) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const mappedDocument = (0, exports.schemaDocument)(data, mapping);
    const document = Object.assign(Object.assign({}, mappedDocument), (((_a = mappedDocument === null || mappedDocument === void 0 ? void 0 : mappedDocument.shopify) === null || _a === void 0 ? void 0 : _a.raw) && Object.assign({}, JSON.parse((_b = mappedDocument === null || mappedDocument === void 0 ? void 0 : mappedDocument.shopify) === null || _b === void 0 ? void 0 : _b.raw))));
    const templated = (0, exports.schemaTemplate)(template, document, templateMapping);
    const schema = mapping[schemaTypes(data, mapping)] || false;
    const type = schemaTypes(data, mapping) || "website";
    const sanityMeta = (document === null || document === void 0 ? void 0 : document.metadata) || ((_e = (_d = (_c = data === null || data === void 0 ? void 0 : data.content) === null || _c === void 0 ? void 0 : _c.edges[0]) === null || _d === void 0 ? void 0 : _d.node) === null || _e === void 0 ? void 0 : _e.metadata) || {};
    const shopifyMeta = (document === null || document === void 0 ? void 0 : document.shopify) || ((_h = (_g = (_f = data === null || data === void 0 ? void 0 : data.content) === null || _f === void 0 ? void 0 : _f.edges[0]) === null || _g === void 0 ? void 0 : _g.node) === null || _h === void 0 ? void 0 : _h.shopify) || {};
    const meta = Object.assign(Object.assign({}, sanityMeta), { title: (sanityMeta === null || sanityMeta === void 0 ? void 0 : sanityMeta.title) || (shopifyMeta === null || shopifyMeta === void 0 ? void 0 : shopifyMeta.seoTitle), description: (sanityMeta === null || sanityMeta === void 0 ? void 0 : sanityMeta.description) || (shopifyMeta === null || shopifyMeta === void 0 ? void 0 : shopifyMeta.seoDescription) });
    const org = organisation || preferences;
    const separator = (org === null || org === void 0 ? void 0 : org.separator) || `|`;
    const metaLang = language || "en_AU";
    const siteName = (org === null || org === void 0 ? void 0 : org.title) || "";
    const siteDescription = (org === null || org === void 0 ? void 0 : org.description) || "";
    const siteURL = (org === null || org === void 0 ? void 0 : org.url) || "";
    const pageTitle = (meta === null || meta === void 0 ? void 0 : meta.title) || (templated === null || templated === void 0 ? void 0 : templated.title) || (document === null || document === void 0 ? void 0 : document.title) || (global === null || global === void 0 ? void 0 : global.title);
    const title = pageTitle !== siteName && pageTitle && siteName ? `${pageTitle} ${separator} ${siteName}` : siteName || "";
    const description = (meta === null || meta === void 0 ? void 0 : meta.description) || (templated === null || templated === void 0 ? void 0 : templated.description) || (document === null || document === void 0 ? void 0 : document.description) || (global === null || global === void 0 ? void 0 : global.description) || siteDescription || "";
    const pageUrl = `${siteURL}${url}` || "";
    const author = (org === null || org === void 0 ? void 0 : org.author) || "";
    const robots = (meta === null || meta === void 0 ? void 0 : meta.noIndex) ? "noindex, nofollow" : "all";
    const canonical = (meta === null || meta === void 0 ? void 0 : meta.canonicalUrl) ? `${siteURL}${meta === null || meta === void 0 ? void 0 : meta.canonicalUrl}` : pageUrl;
    const facebookAppID = (tracking === null || tracking === void 0 ? void 0 : tracking.facebookAppId) || "";
    const googleSiteVerify = (tracking === null || tracking === void 0 ? void 0 : tracking.googleSiteVerify) || "";
    const searchURL = `${siteURL}${(routes === null || routes === void 0 ? void 0 : routes.SEARCH) || "/"}`;
    const socialProfiles = ((_j = social === null || social === void 0 ? void 0 : social.channels) === null || _j === void 0 ? void 0 : _j.map((channel) => channel === null || channel === void 0 ? void 0 : channel.url)) || [];
    const twitterUser = ((_k = social === null || social === void 0 ? void 0 : social.channels) === null || _k === void 0 ? void 0 : _k.filter((channel) => { var _a; return (_a = channel === null || channel === void 0 ? void 0 : channel.title) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes("twitter"); }).map((channel) => channel === null || channel === void 0 ? void 0 : channel.url.replace("https://twitter.com/", ""))) || "";
    const siteImage = (0, exports.schemaImage)({
        alt: `${siteName}`,
        url: `${(_m = (_l = org === null || org === void 0 ? void 0 : org.logo) === null || _l === void 0 ? void 0 : _l.asset) === null || _m === void 0 ? void 0 : _m.url}`,
    });
    const address = (0, exports.schemaAddress)(Object.assign({}, organisation));
    const image = (0, exports.schemaImage)({
        alt: `${title}`,
        url: `${((_p = (_o = meta === null || meta === void 0 ? void 0 : meta.image) === null || _o === void 0 ? void 0 : _o.asset) === null || _p === void 0 ? void 0 : _p.url) || ((_r = (_q = org === null || org === void 0 ? void 0 : org.logo) === null || _q === void 0 ? void 0 : _q.asset) === null || _r === void 0 ? void 0 : _r.url)}`,
    });
    const listItems = [
        (0, exports.schemaListItem)({ name: "Homepage", url: siteURL, position: 1 }),
        ...((breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length)
            ? breadcrumbs.map(({ name, position, url }) => listItems.push((0, exports.schemaListItem)({
                name,
                url: `${siteURL}${url}`,
                position: position || listItems.length + 1,
            })))
            : []),
    ];
    listItems.push((0, exports.schemaListItem)({ name: title, url: pageUrl, position: listItems.length + 1 }));
    return {
        schema,
        document,
        type,
        metaLang,
        siteName,
        siteURL,
        title,
        description,
        pageUrl,
        author,
        robots,
        canonical,
        facebookAppID,
        googleSiteVerify,
        socialProfiles,
        twitterUser,
        siteImage,
        image,
        address,
        searchURL,
        listItems,
    };
};
exports.schemaData = schemaData;
const schemaOrg = ({ address = {}, siteName, siteImage, siteURL, socialProfiles }) => ({
    "@context": "http://schema.org",
    "@type": "Organization",
    url: siteURL,
    name: siteName,
    address,
    logo: siteImage,
    sameAs: socialProfiles,
});
exports.schemaOrg = schemaOrg;
const schemaAddress = ({ addressLocality, addressRegion, postalCode, streetAddress }) => ({
    "@type": "PostalAddress",
    addressLocality: addressLocality || "",
    addressRegion: addressRegion || "",
    postalCode: postalCode || "",
    streetAddress: streetAddress || "",
});
exports.schemaAddress = schemaAddress;
const schemaImage = image => ({
    "@type": "ImageObject",
    description: image.alt || "",
    url: image.url || "",
});
exports.schemaImage = schemaImage;
const schemaListItem = ({ url, name, position }) => ({
    "@type": "ListItem",
    item: {
        "@id": url,
        name,
    },
    position,
});
exports.schemaListItem = schemaListItem;
const schemaBreadcrumbs = ({ listItems }) => ({
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    description: "Breadcrumbs list",
    name: "Breadcrumbs",
    itemListElement: listItems,
});
exports.schemaBreadcrumbs = schemaBreadcrumbs;
const schemaWebSite = ({ title, description, metaLang, author, url, siteURL, searchURL }) => ({
    "@context": "http://schema.org",
    "@type": "WebPage",
    url: url,
    inLanguage: metaLang,
    mainEntityOfPage: siteURL,
    description: description,
    name: title,
    author: (0, exports.schemaPerson)({ name: author }),
    creator: (0, exports.schemaPerson)({ name: author }),
    publisher: (0, exports.schemaPerson)({ name: author }),
    copyrightYear: new Date().getFullYear(),
    copyrightHolder: (0, exports.schemaPerson)({ name: author }),
    potentialAction: {
        "@type": "SearchAction",
        target: `${searchURL}?q={query}`,
        "query-input": "required name=query",
    },
});
exports.schemaWebSite = schemaWebSite;
const schemaSearch = ({ title, url, searchURL, document }) => {
    var _a;
    return ({
        "@context": "http://schema.org",
        "@type": "WebPage",
        url: url,
        name: title,
        potentialAction: {
            "@type": "SearchAction",
            target: `${searchURL}?q={query}`,
            "query-input": "required name=query",
            agent: (0, exports.schemaPerson)({ name: ((_a = document === null || document === void 0 ? void 0 : document.authUser) === null || _a === void 0 ? void 0 : _a.firstname) || `Guest` }),
            query: (document === null || document === void 0 ? void 0 : document.query) || "",
        },
    });
};
exports.schemaSearch = schemaSearch;
const schemaProduct = ({ title, description, url, image, siteURL, document }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return ({
        "@context": "http://schema.org",
        "@type": "Product",
        name: title,
        url: url,
        description: description,
        gtin13: (_a = (0, utils_1.decodeBase64)(document === null || document === void 0 ? void 0 : document.id)) === null || _a === void 0 ? void 0 : _a.replace("gid://shopify/Product/", ""),
        image: image,
        brand: {
            "@type": "Thing",
            name: document === null || document === void 0 ? void 0 : document.vendor,
        },
        sku: (document === null || document === void 0 ? void 0 : document.variants) && (document === null || document === void 0 ? void 0 : document.variants.length) ? document === null || document === void 0 ? void 0 : document.variants[0].sku : "",
        offers: {
            "@type": "AggregateOffer",
            highPrice: ((_c = (_b = document === null || document === void 0 ? void 0 : document.priceRange) === null || _b === void 0 ? void 0 : _b.maxVariantPrice) === null || _c === void 0 ? void 0 : _c.amount) || "",
            lowPrice: ((_e = (_d = document === null || document === void 0 ? void 0 : document.priceRange) === null || _d === void 0 ? void 0 : _d.minVariantPrice) === null || _e === void 0 ? void 0 : _e.amount) || "",
            priceCurrency: ((_g = (_f = document === null || document === void 0 ? void 0 : document.priceRange) === null || _f === void 0 ? void 0 : _f.maxVariantPrice) === null || _g === void 0 ? void 0 : _g.currencyCode) || "",
            offerCount: (_h = document === null || document === void 0 ? void 0 : document.variants) === null || _h === void 0 ? void 0 : _h.length,
            offers: (document === null || document === void 0 ? void 0 : document.variants) ? (_j = document === null || document === void 0 ? void 0 : document.variants) === null || _j === void 0 ? void 0 : _j.map(variant => (0, exports.schemaOffer)({ siteURL, variant: Object.assign({}, variant), handle: document.handle })) : [],
        },
        keywords: [],
    });
};
exports.schemaProduct = schemaProduct;
const schemaBlog = ({ title, url, siteName, siteImage, siteURL, socialProfiles }) => ({
    "@context": "http://schema.org",
    "@type": "Blog",
    name: title,
    url: url,
    publisher: (0, exports.schemaOrg)({ siteName, siteImage, siteURL, socialProfiles }),
    keywords: [],
});
exports.schemaBlog = schemaBlog;
const schemaArticle = ({ title, description, metaLang, author, url, image, siteName, siteImage, siteURL, socialProfiles, document }) => {
    var _a, _b, _c, _d, _e, _f;
    return ({
        "@context": "http://schema.org",
        "@type": "Article",
        articleBody: description,
        author: (0, exports.schemaPerson)({
            name: ((_b = (_a = document === null || document === void 0 ? void 0 : document.attributes) === null || _a === void 0 ? void 0 : _a.author) === null || _b === void 0 ? void 0 : _b.name) || author,
        }),
        copyrightHolder: (0, exports.schemaPerson)({
            name: ((_d = (_c = document === null || document === void 0 ? void 0 : document.attributes) === null || _c === void 0 ? void 0 : _c.author) === null || _d === void 0 ? void 0 : _d.name) || author,
        }),
        copyrightYear: (document === null || document === void 0 ? void 0 : document._createdAt) ? document === null || document === void 0 ? void 0 : document._createdAt.split(`-`)[0] : "",
        creator: (0, exports.schemaPerson)({
            name: ((_f = (_e = document === null || document === void 0 ? void 0 : document.attributes) === null || _e === void 0 ? void 0 : _e.author) === null || _f === void 0 ? void 0 : _f.name) || author,
        }),
        dateModified: (document === null || document === void 0 ? void 0 : document._createdAt) || "",
        datePublished: (document === null || document === void 0 ? void 0 : document._createdAt) || "",
        description: description,
        headline: title,
        image: image,
        inLanguage: metaLang,
        publisher: (0, exports.schemaOrg)({ siteName, siteImage, siteURL, socialProfiles }),
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": siteURL,
        },
        name: title,
        url: url,
    });
};
exports.schemaArticle = schemaArticle;
const schemaStore = ({ title, description, image, author, url, document }) => {
    var _a, _b;
    return ({
        "@context": "http://www.schema.org",
        "@type": "Store",
        address: (document === null || document === void 0 ? void 0 : document.address) || "",
        brand: {
            "@type": "Brand",
            name: author,
        },
        geo: {
            "@type": "GeoCoordinates",
            latitude: (_a = document === null || document === void 0 ? void 0 : document.location) === null || _a === void 0 ? void 0 : _a.lat,
            longitude: (_b = document === null || document === void 0 ? void 0 : document.location) === null || _b === void 0 ? void 0 : _b.lng,
        },
        description: description,
        email: (document === null || document === void 0 ? void 0 : document.email) || "",
        image: image,
        name: title,
        telephone: (document === null || document === void 0 ? void 0 : document.phone) || "",
        url: url,
    });
};
exports.schemaStore = schemaStore;
const schemaPerson = ({ name }) => ({
    "@type": "Person",
    name: name || "",
});
exports.schemaPerson = schemaPerson;
const schemaOffer = ({ siteURL, variant, handle }) => {
    var _a, _b, _c;
    return ({
        "@type": "Offer",
        availability: `http://schema.org/${(variant === null || variant === void 0 ? void 0 : variant.availableForSale) ? `InStock` : `OutOfStock`}`,
        price: ((_a = variant === null || variant === void 0 ? void 0 : variant.priceV2) === null || _a === void 0 ? void 0 : _a.amount) || "",
        priceCurrency: ((_b = variant === null || variant === void 0 ? void 0 : variant.priceV2) === null || _b === void 0 ? void 0 : _b.currencyCode) || "",
        sku: variant === null || variant === void 0 ? void 0 : variant.sku,
        url: `${siteURL}/products/${handle}?variant=${(_c = (0, utils_1.decodeBase64)(variant === null || variant === void 0 ? void 0 : variant.id)) === null || _c === void 0 ? void 0 : _c.replace("gid://shopify/ProductVariant/", "")}`,
    });
};
exports.schemaOffer = schemaOffer;
//# sourceMappingURL=schema.js.map